import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Translate } from '@dreryk/react-common';
import { StyledFlex, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import { sharedTranslationKeys } from '../../translations';

import { attachmentsLinkViewVisitor } from './AttachmentsLinks.utils';
import { AttachmentsLinksView } from './components/AttachmentsLinksView';
import { RemovedLinkView } from './components/RemovedLinkView';
import { AvailableLinkView } from './components/AvailableLinkView';

const t = sharedTranslationKeys.attachmentsLinks;

type AttachmentsCellProps = Readonly<{
   attachments: MedicalInformationAttachment[];
   onShowMoreAttachmentsClick: () => void;
}>;

export const AttachmentsLinks = (props: AttachmentsCellProps): JSX.Element | null => {
   return attachmentsLinkViewVisitor(props.attachments)({
      without: () => null,
      withRemoved: (removedAttachmentsCount) => {
         return (
            <RemovedLinkView
               removedAttachmentsCount={removedAttachmentsCount}
               onShowMoreAttachments={props.onShowMoreAttachmentsClick}
            />
         );
      },
      withAvailable: (attachments, restAttachmentsCounts) => {
         return (
            <StyledFlex direction={'column'} width={'100%'} flexWrap={'wrap'}>
               <AttachmentsLinksView attachments={attachments} />
               {restAttachmentsCounts ? (
                  <AvailableLinkView
                     restAvailableAttachmentsCounts={restAttachmentsCounts}
                     onShowMoreAvailableAttachments={props.onShowMoreAttachmentsClick}
                  />
               ) : null}
            </StyledFlex>
         );
      },
      withAvailableAndRemoved: (attachments, restAvailableAttachmentsCounts, restRemovedAttachmentsCounts) => {
         return (
            <StyledFlex direction={'column'} width={'100%'} flexWrap={'wrap'}>
               <AttachmentsLinksView attachments={attachments} />
               <StyledFlex gap={4}>
                  {restAvailableAttachmentsCounts ? (
                     <AvailableLinkView
                        restAvailableAttachmentsCounts={restAvailableAttachmentsCounts}
                        onShowMoreAvailableAttachments={props.onShowMoreAttachmentsClick}
                     />
                  ) : null}
                  {restRemovedAttachmentsCounts ? (
                     <TextSeparator separator={TextSeparatorType.SPACE}>
                        <Translate>{restAvailableAttachmentsCounts ? t.and : t.or}</Translate>
                        <span>
                           <RemovedLinkView
                              removedAttachmentsCount={restRemovedAttachmentsCounts}
                              onShowMoreAttachments={props.onShowMoreAttachmentsClick}
                           />
                        </span>
                     </TextSeparator>
                  ) : null}
               </StyledFlex>
            </StyledFlex>
         );
      },
   });
};
